export default "__VITE_ASSET__22dc452e__"